import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';

import { catchError, Observable, throwError, timeout } from 'rxjs';
import { ConfigService } from './config.service';
import { AlertService } from '../pages/shared/alert/alert.service';
import { Router } from '@angular/router';
import { SnackbarService } from './snackbar.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    public config: ConfigService,
    public alert: AlertService,
    private snackbarService: SnackbarService,
    private router: Router
  ) {}
  // intercept(req: HttpRequest<any>, next: HttpHandler):
  //   Observable<HttpEvent<any>> {
  //   return next.handle(req);
  // }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    this.config.token = localStorage.getItem('access_token');

    const authReq = this.config.token
      ? req.clone({ headers: req.headers.set('access_token', this.config.token) })
      : req;

    // send cloned request with header to the next handler.
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 504 ||
          error.status === 408 ||
          error.status === 0
        ) {
          setTimeout(() => {
            this.alert.show('Network Error', 'error');
          }, 500);
        }
        if (error.status === 401) {
          this.handleUnauthorized(error);
        }
        return throwError(error);
      })
    );
  }

  handleUnauthorized(error: HttpErrorResponse) {
    const rememberMe = localStorage.getItem('rememberMe');
    if (rememberMe !== 'true') {
      localStorage.clear();
    }
    //Generic error message for unauthorized and not using error message from backend
    const errorMessage = 'Unauthorized';
    this.snackbarService.openSnackBar(errorMessage, 'close', 2000);
    this.router.navigate(['login']);
  }
}
